import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasSession } from './session-state';

export const authGuard: CanActivateFn = () =>
  hasSession() ? true : inject(Router).createUrlTree(['/login']);
